module.exports = __webpack_public_path__ + "static/media/AdobeCC_Step1a_Image17.7b67d894.jpg";